module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"PageContactBillingInformation":{"bankAccountNumber":"č.ú.","bankLabel":"Bankovní spojení","bicSwift":"BIC/SWIFT","commercialRegistration":null,"heading":"Fakturační údaje","iban":"IBAN","tin":"IČ","vatin":"DIČ"}}}')
  delete Component.options._Ctor
}
